import { withCompInfo } from '@wix/editor-elements-integrations'
import { DEFAULT_DURATIONS_MS } from '@wix/thunderbolt-commons'
import type { BackgroundGroupCssVars } from '@wix/thunderbolt-components-native'

// @ts-ignore remove once pageTransition is added to the type
export const css = withCompInfo<BackgroundGroupCssVars, any>()(['pageTransition'], ({ pageTransition }) => {
	const transitionDuration = DEFAULT_DURATIONS_MS[pageTransition as keyof typeof DEFAULT_DURATIONS_MS] ?? 0
	return {
		'--transition-duration': `${transitionDuration}ms`,
	}
})
